import  { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  signInWithGoogle,
  signInWithMicrosoft,
  signInWithEmail,
} from "../../backend/SignIn/SignIn"; // Path to backend functions
import GoogleIcon from "./components/assets/google-logo.png"; // Path to Google logo
import MicrosoftIcon from "../../assets/images/microsoft.png"; // Path to Microsoft logo
import logo from "../../assets/images/logo/logo-with-title.svg"; // Path to Microsoft logo
import "../../css/SignIn/SignIn.css"; // Path to CSS file
import SignInButton from "../DesignSystem/Buttons/SignInButton"; // Path to SignInButton component

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [error, setError] = useState(null);

const sendAlert = async (user) => {
  try {
    const response = await fetch(
      "https://rosemount-explore.onrender.com/SendAlert",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          adviserName: user.displayName || "",
          // adviserEmail: user.email || "",
          date: new Date().toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          }),
        }),
      }
    );

    const result = await response.json();
    if (response.ok) {
      // console.log("Admin alert email sent:", result);
    } else {
      // console.error("Error sending admin alert:", result);
    }
  } catch (error) {
    // console.error("Fetch error:", error);
     try {
       await notifyRenderError(error, "NETWORK_ERROR");
     } catch (e) {}
  }
};

// --- login success handler ---
const handleLoginSuccess = async (user) => {
  if (user?.metadata) {
    const { creationTime, lastSignInTime } = user.metadata;
    // console.log("User metadata:", user.metadata);

    if (creationTime === lastSignInTime) {
      // console.log("New user:", user.email);
      await sendAlert(user); // send email to admin
    } else {
      // console.log("Existing user:", user.email);
    }
  }

  localStorage.setItem("user", JSON.stringify(user)); // Save user info in local storage
  navigate("/home"); // Redirect to home page
};
  // Function to handle email sign-in
  const handleEmailSignIn = async () => {
    setError(null); // Reset error state before attempting sign-in
    try {
      // Await the result from the signInWithEmail function
      const user = await signInWithEmail(email, password);

      if (user) {
        navigate("/home"); // Redirect to home if sign-in is successful
      }
    } catch (error) {
      // console.error("Email Sign-In Error:", error.message);

      // Automatically attempt Microsoft sign-in if the account exists with a different provider
      if (error.code === "auth/account-exists-with-different-credential") {
        // console.warn(
        //   "User account exists with a different provider. Signing in with Microsoft..."
        // );
        handleMicrosoftSignIn();
      } else {
        setError(error.message);
      }
    }
  };

  // Handle Google Sign-In
  const handleGoogleSignIn = async () => {
    try {
      const user = await signInWithGoogle();
      handleLoginSuccess(user);
      // alert(`Google sign-in successful! Welcome ${user.email}`);
    } catch (error) {
      // console.error("Google Sign-In Error:", error.message);

      // If the error is due to an account already linked with Microsoft, sign in with Microsoft instead
      if (error.code === "auth/account-exists-with-different-credential") {
        // console.warn(
        //   "User account exists with a different provider. Signing in with Microsoft..."
        // );
        handleMicrosoftSignIn();
      } else {
        setError(error.message);
      }
    }
  };

  // Handle Microsoft Sign-In
  const handleMicrosoftSignIn = async () => {
    try {
      const user = await signInWithMicrosoft();
      handleLoginSuccess(user);
      // alert(`Microsoft sign-in successful! Welcome ${user.email}`);
    } catch (error) {
      // console.error("Email Sign-In Error:", error.message);

      // Automatically attempt Microsoft sign-in if the account exists with a different provider
      if (error.code === "auth/account-exists-with-different-credential") {
        // console.warn(
        //   "User account exists with a different provider. Signing in with Microsoft..."
        // );
        handleMicrosoftSignIn();
      } else {
        setError(error.message);
      }
    }
  };

  return (
    <div className="SignIn-Container">
      {/* <AddEmails /> */}
      <img src={logo} alt="Logo" />
      <div className="SignIn-Form">
        <SignInButton
          imgSrc={GoogleIcon}
          title="Sign in with Google"
          onClick={handleGoogleSignIn}
        />
        <SignInButton
          imgSrc={MicrosoftIcon}
          title="Sign in with Microsoft"
          onClick={handleMicrosoftSignIn}
        />
      </div>
    </div>
  );
};

export default SignIn;
